import { render, staticRenderFns } from "./AuthorizationDialog.vue?vue&type=template&id=4898f789&scoped=true"
import script from "./AuthorizationDialog.vue?vue&type=script&lang=ts"
export * from "./AuthorizationDialog.vue?vue&type=script&lang=ts"
import style0 from "./AuthorizationDialog.vue?vue&type=style&index=0&id=4898f789&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4898f789",
  null
  
)

export default component.exports